<div class="formborder mt-2">
  <ng-container>
    <div class="row m-0 mt-2 h-b w-b justify-content-between align-items-center" style="width: 100%">
      <h1 class="fs-12 m-0">Pre Closure Detail:</h1>
      <div class="d-flex align-items-center">

        <input  type="checkbox" class=" ml-2" [(ngModel)]="isCheckedCustomer"
          (change)="LMS_Get_Loan_Closer_Due_Detail(null)" />
        <label  class="mt-1">Customer Copy</label>
      </div>
    </div>

    <div class="row m-0 mt-3" id="printData">
      <div style="width: 100%; padding-left: 1.25rem; padding-right: 1.25rem">
        <div class="row m-0 mt-3">
          <div class="col-md-3">
            <h6 class="fs-12">Request Status</h6>
            <p [ngClass]="{
                'text-danger':
                  PreCloserDetails.Closer_RequestStatus == 'Waiver Rejected',
                'text-success':
                  PreCloserDetails.Closer_RequestStatus == 'Waiver Approved'
              }">
              {{ PreCloserDetails.Closer_RequestStatus }}
            </p>
            <p *ngIf="PreCloserDetails.TotalWaiver_Approved">
              Approved Waiver Amount:<b>
                ₹{{ PreCloserDetails.TotalWaiver_Approved }}</b>
            </p>
          </div>

          <div class="col-md-3">
            <h6 class="fs-12">Last Transaction Date</h6>
            <p>{{ PreCloserDetails.lastTrasactionDate }}</p>
          </div>
          <div class="col-md-3">
            <h6 class="fs-12">Pre-Closure Effective Date</h6>
            <div class="datepicker_feild">
              <input [matDatepicker]="picker" dateConvert placeholder="DD/MM/YYYY"
                [(ngModel)]="PreCloserDetails.LoanCloser_EffectiveDate" [min]="MinEffectiveDate"
                [max]="PreCloserDetails.NextDueDate" name="LoanCloser_EffectiveDate" id="LoanCloser_EffectiveDate"
                (dateChange)="onEffectiveDateChange()" [disabled]="PreCloserDetails.Closer_RequestStatus != 'Created'"
                class="form-control input-text-css" />
              <mat-datepicker-toggle matSuffix [for]="picker" style="right: 0 !important"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </div>
          </div>
        </div>

        <table style="margin-bottom: 1.25rem">
          <tbody>
            <tr style="background: var(--theme-tint)">
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                <b>Account Head</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Due</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Received</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Waiver</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Balance</b>
              </td>
            </tr>
            <tr *ngFor="let preCloserData of PreCloserMethodList; let i = index" style="height: 2.6875rem">
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                {{ preCloserData.ChagesHead }}
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                {{ preCloserData.DueAmount }}
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                {{ preCloserData.ReceiveAmount }}
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <input type="text" [(ngModel)]="preCloserData.WaiverAmount" placeholder="amount"
                  name="WaiverAmount{{ i }}" id="WaiverAmount{{ i }}" class="form-control input-text-css" disabled
                  style="width: 5.625rem; margin: 0px auto" (ngModelChange)="onChangeWaiverAmt($event, preCloserData)" />
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                {{ preCloserData.Balance }}
              </td>
            </tr>
            <tr *ngIf="PreCloserMethodList.length > 0 && totalCalculator" style="background: #120eeb29">
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Total :</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ totalCalculator.totalDueAmount?.toFixed(2) }}</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ totalCalculator.totalReceiveAmount?.toFixed(2) }}</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ totalCalculator.totalWaiverAmount?.toFixed(2) }}</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ totalCalculator.totalBalance?.toFixed(2) }}</b>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="row m-0 h-b w-b" style="width: 100%" *ngIf="LoanChargesRecoverableList">
          <h1 class="fs-12 m-0">Detail Of Loan Charges Recoverable</h1>
        </div>
        <table style="margin-bottom: 1.25rem; width: 50%" *ngIf="LoanChargesRecoverableList">
          <tbody>
            <tr style="background: #120eeb29">
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Head</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>Amount</b>
              </td>
            </tr>
            <tr *ngFor="
                let LoanCharges of LoanChargesRecoverableList;
                let i = index
              " style="height: 2.6875rem">
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                {{ LoanCharges.ChagesHead }}
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                {{ LoanCharges.Amount?.toFixed(2) }}
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                <b>Total</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ LoanChargesRecoverable.Due_Amount?.toFixed(2) }}</b>
              </td>
            </tr>
            <tr>
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                <b>Received</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ LoanChargesRecoverable.Received_Amount?.toFixed(2) }}</b>
              </td>
            </tr>
            <tr style="background: #120eeb29">
              <td style="border: 1px solid #b5b0b0; padding: 0.3125rem">
                <b>Balance</b>
              </td>
              <td style="
                  border: 1px solid #b5b0b0;
                  padding: 0.3125rem;
                  text-align: center;
                ">
                <b>{{ LoanChargesRecoverable_Balance?.toFixed(2) }}</b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>